import React from 'react';
import DocumentLink from '../documentLink';

const ReportLink = ({game, reportType, reportName, urlOverride, disabled}) => {

    const sendGaClickEvent = label => {
        window.dataLayer.push({
            event: 'click',
            'event_category': `${reportName} Report`,
            'event_label': label
        });
    };

    const reportId = `${reportType}${game.id.toString().slice(4, 6)}${game.id.toString().slice(6, 10)}`;
    const reportUrl = `http://www.nhl.com/scores/htmlreports/${game.season.id}/${reportId}.HTM`;

    return (
        <DocumentLink
            link={urlOverride ? urlOverride : reportUrl}
            text={reportName}
            onClick={sendGaClickEvent.bind(this, reportName)}
            disabled={disabled}
        />
    );
};

export default ReportLink;
